import TextCell from 'components/TextCell';
import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function FmsIdCell({ rowData: { dmsId } }: CellProps) {
  return <TextCell text={dmsId} />;
}
